import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import { clientAppSettings } from "../../Models/ClientAppSettings";
import { CultureUtility } from '../../Resources/CultureUtility';
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";

export interface WebChatProps extends React.Props<WebChat> {
    bot: Rest.BotService;
    authoringDirty: boolean;
    authoringError: boolean;
    className?: string;
}

export interface WebChatState {
    token: string;
}

export class WebChat extends React.Component<WebChatProps, WebChatState> {

    constructor(props: WebChatProps) {
        super(props);

        this.state = { token: null };

        this.retrieveWebChatToken();
    }

    public render(): JSX.Element {
        if (!this.state.token) {
            return null;
        }

        let frameSrc = `${clientAppSettings.webChatUrl}embed/${this.props.bot.Id}?t=${this.state.token}`;
        if (CultureUtility.rawLocale)
            frameSrc += `&l=${CultureUtility.rawLocale}`;

        return (
            <div className="webchat-iframe-wrapper">
                 <div className="webchat-test-header">
                    <div className="webchat-test-text">{Resources.test}</div>
                    <button className="webchat-test-reload"
                            onClick={() => this.retrieveWebChatToken()}>
                        <span className="m-icon-Refresh webchat-refresh" ></span>
                            <span className="webchat-startover-text">
                                {Resources.startOver}
                            </span>
                    </button>
                </div>
                <iframe title="Web chat" className={this.props.className} src={frameSrc}></iframe>
                <div className="warning-wrapper">
                    {this.renderUnsavedWarnings()}
                    {this.renderError()}
                </div>
            </div>
        );
    }

    private retrieveWebChatToken() {
        Rest.BotManagerClient.getWebChatToken(this.props.bot.Id).done(token => {
            this.setState({ token: token });
        });
    }

    private renderUnsavedWarnings(): JSX.Element {
        if (this.props.authoringDirty) {
            return (
                <div className="bot-alert">
                    <span className="bot-unsave-warning m-icon-AlertTriangle"></span>
                    <span>You have unsaved changes in BUILD. Testing won’t reflect those changes. </span>
                </div>
            );
        }

        return null;
    }

    private renderError(): JSX.Element {
        if (this.props.authoringError) {
            return (
                <div className="bot-alert bot-alert-second">
                    <span className="bot-error-warning m-icon-AlertCircle"></span>
                    <span>You have errors in BUILD. Please fix these changes before continuing.</span>
                </div>
            );
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/WebChat.tsx